import Swiper from 'swiper/bundle';

/* Home */
const homeTeamSwiper = new Swiper(".homeTeamSwiper", {
    grabCursor: true,
    keyboard: true,	
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },		
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1.25,
    spaceBetween: 30,
    breakpoints: {
        768: {
            slidesPerView: 2.25,
            spaceBetween: 25,
            slidesPerGroup: 2
        },
        1080: {
            slidesPerView: 3,
            spaceBetween: 30,
            slidesPerGroup: 3
        },
    }

});	

const homeTestimonialSwiper = new Swiper(".homeTestimonialSwiper", {
    grabCursor: true,
    loop: true,
    keyboard: true,	
    pagination: {
        el: ".swiper-pagination-1",
        clickable: true,
    },
    keyboard: true,			
    navigation: {
        nextEl: ".swiper-button-next-1",
        prevEl: ".swiper-button-prev-1",
    }
});	


/* Single project */
const explorationSwiper = new Swiper(".explorationSwiper", {
    grabCursor: true,
    keyboard: true,	
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    keyboard: true,			
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
});	


const whattheysaySwiper = new Swiper(".whattheysaySwiper", {
    grabCursor: true,
    keyboard: true,
    navigation: {
      nextEl: ".swiper-button-next-m1",
      prevEl: ".swiper-button-prev-m1",
    },
});
  
/* function updateSwiperConfiguration() {

    console.log(whattheysaySwiper.params.navigation);
    const screenWidth = window.innerWidth;
  
    if (screenWidth <= 992) {
      whattheysaySwiper.params.navigation.nextEl = ".swiper-button-next-1";
      whattheysaySwiper.params.navigation.prevEl = ".swiper-button-prev-1";
      console.log("small");
    } else {
      whattheysaySwiper.params.navigation.nextEl = ".swiper-button-next-m1";
      whattheysaySwiper.params.navigation.prevEl = ".swiper-button-prev-m1";
      console.log("big");
    }
  
    // Update the Swiper navigation
    whattheysaySwiper.navigation.update();
    console.log('after: ' + whattheysaySwiper.params.navigation);
}
  
// Call the function on page load and whenever the window is resized
window.addEventListener("load", updateSwiperConfiguration);
window.addEventListener("resize", updateSwiperConfiguration); */

